<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash"  ref="SetBtn"></buttonlist>
        <div style="display: flex">
            <div style="width:20%;">
                <div :style="{height: treeheight1}">
                    <el-card class="box-card" style="height:100%;overflow-y: scroll">
                        <div style="margin-top:5px;inbackground: white;">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree :data="dataTree" :props="defaultProps" default-expand-all="true" @node-click="handleNodeClick"></el-tree>
                            </el-scrollbar>
                        </div>
                    </el-card>
                </div>
                <div>
                    <el-card class="box-card" style="height:70px">
                    <el-divider content-position="left">{{$t('getapi[6076]')}}</el-divider>
                    <el-button @click.native.prevent="freeze('')" type="text" size="small" :disabled="!authority_freeze">{{
                        $t('getapi[6074]') }}
                    </el-button>
                    <el-button @click.native.prevent="draw('')" type="text" size="small" :disabled="!authority_freeze">{{
                        $t('getapi[6075]') }}
                    </el-button>
                    </el-card>
                </div>
            </div>
            <div style="width:80%">
                <div :style="{height: treeheight2}">
                    <el-card class="box-card" style="height:100%">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" :disabled="!btn.edit"  @click="editInfo" >{{$t('getapi[34]') }}</el-button>                            
                            <el-button type="primary" size="mini" :disabled="!btn.frozen"  @click="freeze">{{$t('getapi[555]') }}</el-button>
                            <el-button type="primary" size="mini" :disabled="!btn.unfreeze" @click="draw">{{$t('getapi[591]') }}</el-button>
                            <el-button type="primary" size="mini" :disabled="!btn.tlevel" @click="twolveditInfo">{{$t('getapi[6846]')}}</el-button>
                            <el-button type="primary" size="mini" :disabled="!btn.del" @click="del" >{{ $t('getapi[40]') }}</el-button>
                            <el-button type="primary" size="mini" :disabled="selData.length != 1" @click="pageAuthSet" >{{ $t('getapi[13124]') }}</el-button>
                        </div>
                    <el-table
                            id="xpane-0"
                            :data="dataSet"
                            v-loading="loading"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            :height="tableHeight"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:0px"
                            :header-cell-style="$limits.headerClass"
                            @selection-change="handleSelectionChange"
                            ref="singleTable"
                    >
                        <el-table-column type="selection" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="usernum" :label="$t('getapi[3223]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="usercode" :label="$t('getapi[3224]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="userid" :label="$t('getapi[3225]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="username" :label="$t('getapi[3226]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="loginpassword" :label="$t('getapi[3227]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="deptname" :label="$t('getapi[3151]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="postname" :label="$t('getapi[3228]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="login_limit" :label="$t('getapi[3229]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remarks" :label="$t('getapi[143]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="freeze_flag" :label="$t('getapi[6072]')">
                            <template scope="scope">
                                <span>{{ scope.row.freeze_flag | lanchange}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="inner_flag" :label="$t('getapi[6073]')">
                            <template scope="scope">
                                <span>{{ scope.row.inner_flag | lanchange}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="leave_flag" :label="$t('getapi[12368]')">
                            <template scope="scope">
                                <span>{{ scope.row.leave_flag | lanchange}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="tlevel" v-if="userData.Login_Code == 'boss'" :label="$t('getapi[6846]')">
                            <template scope="scope">
                                <span>{{ scope.row.tlevel | lanchange}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="cpuid" label="ID"></el-table-column>
                        
                        
                        <!-- <el-table-column :label="$t('getapi[6048]')" fixed="right" width="130px">
                            <template slot-scope="scope">
                                <el-popconfirm
                                        :confirmButtonText="$t('getapi[937]')"
                                        :cancelButtonText="$t('getapi[6]')"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        :title="$t('getapi[637]')"
                                        @onConfirm="del(scope.row)"
                                >
                                     <el-button slot="reference" type="text" size="small" :disabled="!authority_del  || scope.row.userid== 'boss'" >{{ $t('getapi[40]') }}</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </el-card>
                </div>
            </div>
        </div>
        <serce :isVisible="isVisible" queryData="FrmUserPerShowViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 二级权限设置弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isTwoLVPerDetail" width="400px" top="60px" :title="$t('getapi[6847]')">
            <div >
                <div >                  
                    <vxe-table
                        :data="twolvperdetail"
                        size="mini"
                        :highlight-current-row="true"
					>                   
                    <vxe-table-column field="visiable"  :title="$t('getapi[6848]')"  align="center"  width="80px">
						<template slot-scope="scope" >
							<el-checkbox v-model="scope.row.visiable" :true-label="1" :false-label="0"></el-checkbox>
						</template>
					</vxe-table-column>
                    <vxe-table-column show-footer-overflow field="perid" :title="$t('getapi[871]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="pername" :title="$t('getapi[6849]')" width="200px"></vxe-table-column>
                    </vxe-table>                                    
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isTwoLVPerDetail = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="twolvsave" :disabled="!authority_edit">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowUserAuth" width="400px" top="60px" :title="$t('getapi[13130]')">
            <div >
                <table>
                    <tr>
                        <td>{{ $t('getapi[13125]') }}</td>
                        <td>
                            <el-select filterable v-model="pagename"  size="mini" style="margin-righ:20px" @change="getPageData">
                                <el-option v-for="item in pagearr" :key="item.Page_Name" :label="$t('getapi['+item.Page_LangId+']')" :value="item.Page_Name"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <span style="color: blue">{{pageAuthTips}}</span>
                        </td>
                    </tr>
                </table>
                <vxe-table
                        ref="singleTable"
                        :data="dataAuth"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        resizable
                        size="mini"
                        height="600"
                        header-row-class-name="headerclass"
                        show-overflow="tooltip"
                        style="width: 100%; margin-top:0px"
                        :auto-resize="true"
                >
                    <vxe-table-column type="checkbox" align="center" width="40" v-if="false"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Page_Name" :title="$t('getapi[13125]')" width="100">
                        <template slot-scope="scope">
                            {{$t('getapi['+scope.row.Page_LangId+']')}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="Field_Name" :title="$t('getapi[13126]')" width="100">
                        <template slot-scope="scope">
                            {{$t('getapi['+scope.row.Field_LangId+']')}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="AuthCode" :title="$t('getapi[13127]')" width="100" align="center">
                        <template slot-scope="scope">
                            <el-checkbox size="mini" v-model="scope.row.AuthCode"  true-label="1" false-label="0"></el-checkbox>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowUserAuth = false">{{$t('getapi[2054]')}}</el-button>
                <el-button size="mini" type="primary" @click="delUserAuth">{{$t('getapi[40]')}}</el-button>
				<el-button size="mini" type="primary" @click="saveUserAuth">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <!-- 编辑弹窗 -->
        <el-dialog v-dialogDrag :visible.sync="isShowDetail" width="50%" top="50px" @close="closeDialog">
            <div style="width:100%;margin-top: 30px">
                <div style="width:100%;display: flex;">
                    <div style="width:30%">
                        <div>
                            <div  style="height:300px">
                                <el-divider content-position="left">{{$t('getapi[3543]')}}</el-divider>
                                <table>
                                    <tr>
                                        <td>{{$t('getapi[3201]')}}</td>
                                        <td>
                                            <!--<el-input v-model="dataDetail.UserName" type="text" size="mini"></el-input>-->
                                            <el-input v-model="dataDetail.UserName" type="text"
                                                      readonly
                                                      class="mcolor"
                                                      v-if="addoredit == 2"
                                                      size="mini">
                                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee()"></i>
                                            </el-input>
                                            <el-input v-model="dataDetail.UserName" size="mini" :disabled="true" v-if="addoredit != 2"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('getapi[3151]')}}</td>
                                        <td>
                                            <el-select filterable v-model="dataDetail.DeptID" :placeholder="$t('getapi[6085]')" size="mini" :disabled="true">
                                                <el-option v-for="item in arrDept" :key="item.num" :label="item.name" :value="item.num"></el-option>
                                            </el-select>
                                            <!--<el-input v-model="dataDetail.deptname" type="text" size="mini"></el-input>-->
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('getapi[3165]')}}</td>
                                        <td>
                                            <el-input v-model="dataDetail.postname" type="text" size="mini" :disabled="true"></el-input>
                                            <!-- <el-select filterable v-model="dataDetail.PostID" :placeholder="$t('getapi[6085]')" size="mini" :disabled="true">
                                                <el-option v-for="item in arrPost" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                                            </el-select> -->
                                            <!--<el-input v-model="dataDetail.postname" type="text" size="mini"></el-input>-->
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('getapi[3255]')}}</td>
                                        <td>
                                            <el-input v-model="dataDetail.UserID" type="text" size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>ID</td>
                                        <td>
                                            <el-input v-model="dataDetail.CpuID" type="text" size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span v-if="resetPas == 1 || addoredit == 2">{{$t('getapi[3544]')}}</span></td>
                                        <td>
                                            <el-input v-model="dataDetail.Pwd" show-password size="mini" v-if="resetPas == 1 || addoredit == 2"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-if="addoredit != 2">{{$t('getapi[3545]')}}<el-checkbox v-model="resetPas" true-label="1" false-label="0"></el-checkbox></td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div>
                                    <el-divider content-position="left">{{$t('getapi[3546]')}}</el-divider>
                                    <div style="height:340px">
                                        <el-table
                                                :data="roleDetail"
                                                size="mini"
                                                style="width: 100%"
                                                :highlight-current-row="true"
                                                @row-click="selectRow">
                                            <el-table-column prop="rolename" label="" width="180"></el-table-column>
                                        </el-table>
                                        <!--<ul>
                                            <li v-for="item in roleDetail" :key="item.roleid">{{item.rolename}}</li>
                                        </ul>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width:70%">
                        <div>
                            <el-divider content-position="left">{{$t('getapi[3547]')}}</el-divider>
                            <table>
                                <td>{{$t('getapi[3548]')}}</td>
                                <td>
                                    <el-input v-model="treeQueryKey" type="text" size="mini"></el-input>
                                </td>
                                <td><el-button size="mini" @click="searchTree">{{$t('getapi[1980]')}}</el-button></td>
                                <td><el-button size="mini" @click="back">{{$t('getapi[3549]')}}</el-button></td>
                                <td><el-button size="mini" @click="next">{{$t('getapi[3550]')}}</el-button></td>
                            </table>
                        </div>
                        <div style="height:600px;overflow: scroll" id="searchtree-eletree">
                            <el-tree ref="tree"
                                     :data="detailDataTree"
                                     :props="detailDefaultProps"
                                     show-checkbox
                                     check-strictly
                                     highlight-current
                                     node-key="PerID"
                                     :default-checked-keys="defaultchecked"
                                     @check="handleCheck"
                                     :default-expanded-keys="defaultEexpandedkeys"
                                     :filter-node-method="filterNode"></el-tree>
                        </div>
                    </div>
                </div>
                <div style="width:100%;display: flex;">
                    <div style="width:30%">
                        <div v-if="authority_save">
                            <el-card class="box-card" style="height:100%">
                                <el-button type="text" size="small" @click="showRole">{{
                                    $t('getapi[3553]') }}
                                </el-button>
                                <el-button type="text" size="small" @click="deleteRole">{{
                                    $t('getapi[3554]') }}
                                </el-button>
                            </el-card>
                        </div>
                    </div>
                    <div style="width:70%">
                        <div v-if="authority_save">
                            <el-card class="box-card" style="height:100%">
                                <el-button type="text" size="small" @click="saveRole">{{
                                    $t('getapi[3556]') }}
                                </el-button>
                            </el-card>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDetail = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save" :disabled="!authority_save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowSaveRole" width="30%">
            <div>
                <el-divider content-position="left">{{$t('getapi[6091]')}}</el-divider>
                <table>
                    <tr>
                        <td>{{$t('getapi[3216]')}}</td>
                        <td>
                            <el-input v-model="roleid" type="text" size="mini" :placeholder="$t('getapi[3580]')" :disabled="true"></el-input>
                        </td>
                        <td>{{$t('getapi[3215]')}}</td>
                        <td>
                            <el-select filterable  v-model="groupid"  :placeholder="$t('getapi[6085]')" size="mini">
                                <el-option v-for="item in arrRoleGroup" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[3217]')}}</td>
                        <td colspan="3">
                            <el-input v-model="rolename" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowSaveRole = false">{{$t('getapi[2054]')}}</el-button>
                    <el-button type="primary" @click="confirmSaveRole">{{$t('getapi[1146]')}}</el-button>
                </span>
        </el-dialog>

        <!--<role :isVisible="isShowRole" @getrole="getrole" ref="role"></role>-->
        <selector :isVisible="isShowRole" :isSplitPage=true
                  :postUrl="'/Sys/Authority/GetFillRoleList'" @callback="getrole" ref="role"></selector>
        <!--人员-->
        <!--<roleemp :isVisible="employeeVisible" @getroleemp="getroleemp" ref="roleemp"></roleemp>-->
        <selector :isVisible="employeeVisible" :isSplitPage=true
                  :postUrl="'/Sys/Authority/GetSysEmpRightDataList'" @callback="getroleemp" ref="roleemp"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
		name:'userauthorityset',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            },
            treeheight1(){
                return this.$windowSize.tableHeight - 230 + 'px'
            },
            treeheight2(){
                return this.$windowSize.tableHeight - 155 + 'px'
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                isShowDetail: false, //
                isTwoLVPerDetail:false,
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail:{},
                dataTree: [], // 角色分类树
                defaultProps: {
                    children: 'Children',
                    label: 'name',
                    num: 'num'
                },
                detailDataTree: [],
                //二级管理员权限
                twolvperdetail:[],
                cacheDataTree: [],
                detailDefaultProps: {
                    children: 'Children',
                    label: 'PerNameID',
                    PLevel:'PLevel',
                    ParentID:"ParentID",
                    PerID:"PerID",
                    PerType:'PerType',
                    PerMainPos:'PerMainPos',
                    PerSubPos:'PerSubPos',
                    MainPos:'MainPos',
                    IsCheck:'IsCheck',
                    Visiable:'Visiable'
                },
                defaultchecked: [],
                defaultEexpandedkeys: [],
                arrDept: [], //部门信息
                arrPost: [], // 岗位信息
                isShowRole: false,
                roleDetail: [],
                selectrow:{},
                isShowSaveRole: false,
                arrRoleGroup: [],
                roleid: "",
                rolename: "",
                groupid: "",
                isShowPas: false, // 是否显示初始密码
                resetPas: 0, // 是否重置密码
                addoredit: 2, //1:修改2：新增
                maxauthority: false, //是否最大权限
                treeQueryKey: '',
                searchIndex: null,
                searchData: [], //模糊匹配的树节点
                employeeVisible: false,
                queryData: [], // 查询数组
                usernum:0,
                userid:"",
                authority_edit: false,
                authority_save: false,
                authority_del: false,
                authority_freeze: false,
                selectdata: {}, //当前选择的部门
                selData: [],
                btn:{
                    edit:false,
                    del:false,
                    tlevel:false,
                    frozen:false,
                    unfreeze:false,
                },
                scrollTop:0,
                //页面权限设置
                isShowUserAuth:false,
                UserID:'',
                UserName:'', //用户
                pagename:'',// 页面名称
                pagearr:[], // 页面数组
                dataAuth:[], //页面数据
                pageAuthTips:'',
            };
        },
        created: function() {
            let that = this;
            that.arrDept = Array.methods.getDeptInfo();
            that.arrPost = Array.methods.getPostInfo();
            that.arrRoleGroup = Array.methods.getRoleGroup()
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.btn.edit=false;
            that.btn.del=false;
            that.btn.tlevel=false;
            that.btn.unfreeze=false;
            that.btn.frozen=false;
            that.getView()
            that.getPageArr()
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            handleSelectionChange(val) {
                let that = this
                that.selData = val
                that.btnauthority()
            },
            filterNode(value,data){
              return data.Visiable == value
            },
            filterChange(){
                this.$nextTick(() => {
                    this.$refs.tree.filter(1)
                    // 当执行过滤后，会默认展开，这边遍历树，全部收缩
                    this.shrink().filter(this.detailDataTree);
                })
            },
            shrink: function(){
                let that = this
                let shrink_ = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.PerID != '-') {
                        that.$refs.tree.store.nodesMap[obj.PerID].expanded = false
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            shrink_(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            shrink_(rootMenu);
                        }
                    }
                };
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1073]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.authority('plv2', 10, 1) == 1) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                //操作权
                if (that.$limits.authority('plv2', 10, 1) == 2) {
                    //查询级
                    if (that.$limits.authority('plv3', 10, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                    if (that.$limits.authority('plv3', 10, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                    }
                    if (that.$limits.authority('plv3', 10, 1) == 2) {
                        //删除级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                    }
                }

                if(that.$limits.authority('plv4', 43, 1) ==  1){
                    that.authority_freeze = true
                } else {
                    that.authority_freeze = false
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this;
                that.btn.edit=false;
                that.btn.del=false;
                that.btn.tlevel=false;
                that.btn.unfreeze=false;
                that.btn.frozen=false;
                that.authority_save = false;
                if (that.$limits.authority('plv2', 10, 1) == 2) {
                    //查询级
                    if (that.$limits.authority('plv3', 10, 1) == 0) {
                        that.authority_save = false;
                    }
                    if (that.$limits.authority('plv3', 10, 1) == 1) {
                        //编辑级
                        that.authority_save = true;
                    }
                    if (that.$limits.authority('plv3', 10, 1) == 2) {
                        //删除级
                        that.authority_save = true;
                    }
                }
                if(that.selData.length==1){
                    that.authority_edit = false;
                    that.authority_del = false;

                    //操作权
                    if (that.$limits.authority('plv2', 10, 1) == 2) {
                        //查询级
                        if (that.$limits.authority('plv3', 10, 1) == 0) {
                            if(that.selData.length==1){
                                that.authority_edit = false;
                                that.authority_del = false;
                            }
                        }
                        if (that.$limits.authority('plv3', 10, 1) == 1) {
                            //编辑级
                            if(that.selData.length==1){
                                that.authority_edit = true;
                                that.authority_del = false;
                            }
                        }
                        if (that.$limits.authority('plv3', 10, 1) == 2) {
                            //删除级
                            if(that.selData.length==1){
                                that.authority_edit = true;
                                that.authority_del = true;
                            }
                        }
                    }
                    if(that.userData.Login_Code == 'boss'){
                        that.btn.tlevel=true;
                    }
                    else{
                        that.btn.tlevel=false;
                    }
                    if(that.selData[0].inner_flag == '否' || that.userData.Login_Code == 'boss'){
                        that.btn.edit=true;
                    }
                    else{
                        that.btn.edit=false;
                    }
                    if((that.selData[0].inner_flag == '否' || that.userData.Login_Code == 'boss') && that.selData[0].freeze_flag == '否' && that.authority_freeze)
                    {
                        that.btn.frozen=true;
                    }
                    else{
                        that.btn.frozen=false;
                    }

                    if((that.selData[0].inner_flag == '否' || that.userData.Login_Code == 'boss') && that.selData[0].freeze_flag == '是' && that.authority_freeze){
                        that.btn.unfreeze=true;
                    }
                    else{
                        that.btn.unfreeze=false;
                    }

                    if(that.authority_del  || that.selData[0].userid== 'boss'){
                        console.log("删除权限:"+that.authority_del)
                        that.btn.del=true;
                    }
                    else{
                        that.btn.del=false;
                    }
                } else {
                    that.btn.edit=false;
                    that.btn.del=false;
                    that.btn.tlevel=false;
                    that.btn.unfreeze=false;
                    that.btn.frozen=false;
                }

            },
            add(){
                let that = this
                that.isShowDetail = true
                that.isShowPas = true
                that.addoredit = 2
                that.defaultEexpandedkeys = []
                that.cacheDataTree = []
                let parm = {
                    UserNum: 0
                }
                that.$http.urlpost('/Sys/Authority/GetUserRoleAuthorityList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent.UserInfo
                        that.roleDetail = res.DataContent.RoleGroupList
                        that.detailDataTree = res.DataContent.AuthorityList
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                        that.defaultEexpandedkeys.push('-')
                        that.filterChange()
                        that.authority();
                    }
                });
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.getView();
                this.intidata()
            },
            getView(){
                let that = this
                that.loading = true;
                let parm = {}
                that.$http.urlpost('/Sys/Authority/GetDeptLists', parm, function (res) {
                    if (res.Success == 1) {
                        let tree = res.DataContent;
                        that.dataTree = [{
                            GroupName: "",
                            GroupID: "",
                            Children: []
                        }]
                        that.dataTree[0].name = "所有部门"
                        that.dataTree[0].num = ""
                        that.dataTree[0].Children = tree
                        that.loading = false;
                        that.authority();
                    }
                });
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FrmUserPerShowViewInfo');
            },
            reflash() {
                let that = this;
                that.getView();
                if(that.selectdata != {}){
                    that.handleNodeClick(that.selectdata)
                } else {
                    that.intidata()
                }

            },
            handleNodeClick(data){
                let that = this
                that.selectdata = data
                let parm = {
                    deptid: data.num
                }
                that.$http.urlpost('/Sys/Authority/GetEmployeeDataList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                });
            },
            intidata(){
                let that = this
                that.selectdata = {}
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    Param: datac
                };
                that.$http.urlpost('/Sys/Authority/GetEmployeeDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                });
            },
            freeze(){
                let that = this
                let parm = {}
                if(that.selData.length ==0){
                    parm = {
                        type: 1,
                        userid: ''
                    }
                } else {
                    parm = {
                        type: 1,
                        userid: that.selData[0].userid
                    }
                }
                that.$http.urlpost('/Sys/Authority/FrozenUser', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.reflash();
                    }
                });
            },
            draw(){
                let that = this
                let parm = {}
                
                if(that.selData.length==0){
                    parm = {
                        type: 2,
                        userid: ''
                    }
                } else {
                    parm = {
                        type: 2,
                        userid: that.selData[0].userid
                    }
                }
                that.$http.urlpost('/Sys/Authority/FrozenUser', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.reflash();
                    }
                });
            },
            editInfo() {
                let that = this
                that.isShowDetail = true
                that.addoredit = 1
                that.defaultEexpandedkeys = []
                that.resetPas = 0
                let parm = {
                    UserNum: that.selData[0].usernum
                }
                that.$http.urlpost('/Sys/Authority/GetUserRoleAuthorityList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent.UserInfo
                        that.roleDetail = res.DataContent.RoleGroupList
                        that.detailDataTree = res.DataContent.AuthorityList
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                        that.defaultEexpandedkeys.push('-')
                        that.filterChange()
                    }
                });
            },
            twolveditInfo() {
                let that = this
                that.isTwoLVPerDetail = true
                that.twolvperdetail = []
                that.usernum=that.selData[0].usernum,
                that.userid=that.selData[0].userid
                let parm = {
                    usernum: that.usernum,
                    userid: that.userid
                }
                that.$http.urlpost('/Sys/Authority/GetTwoLVPermission', parm, function (res) {
                    if (res.Success == 1) {
                        that.twolvperdetail = res.DataContent.List
                    }
                });
            },
            twolvsave() {
                let that = this
                console.log("二级数据"+JSON.stringify(that.twolvperdetail))             
                let parm = {
                    usernum: that.usernum,
                    userid: that.userid,
                    List: that.twolvperdetail
                }
                that.$http.urlpost('/Sys/Authority/SaveTwoLVPermission', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isTwoLVPerDetail = false
                    }
                });
            },
            handleCheck(data,checked){
                let that = this
                let arr = checked.checkedKeys
                let isChecked = false
                for(let i=0;i<arr.length;i++){
                    if(arr[i] == data.PerID){
                        isChecked = true
                        break
                    } else {
                        isChecked = false
                    }
                }
                if(isChecked == true) { // 勾选
                    if(data.Children.length == 0){ // 勾选子节点
                        if(data.PerType == "O"){ // 查询 ，编辑 ， 删除互斥
                            let parentid = data.ParentID
                            let type = 1
                            if(data.PerName == "查询级"){
                                type = 1
                            }  else if (data.PerName == "编辑级"){
                                type = 2
                            } else if(data.PerName == "删除级"){
                                type = 3
                            }
                            that.recursivetrueSon().filter(that.detailDataTree,parentid,type)
                            that.tickMenuIdFilter().filter(that.detailDataTree);
                        } else {
                            if(checked == true){
                                data.IsCheck = true
                            }  else {
                                data.IsCheck = false
                            }
                        }
                    } else { // 勾选父节点
                        that.recursivetrueCancel().filter(data)
                        that.recursivetrue().filter(data)
                    }
                    that.detailDataTree[0].IsCheck = true
                    that.checkParent(data,that.detailDataTree, 'PerID','ParentID', '-')
                    setTimeout(() => {
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                    }, 100);
                } else { // 取消勾选
                    that.recursivetrueCancel().filter(data)
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                }
            },
            // 选中时，勾选其父节点
            checkParent(node, data, PerID, ParentID, rootId){
                let that = this
                if(!node) return;
                if(node[PerID] == rootId) {
                    node.IsCheck = true
                    return;
                }
                let pNode = that.getParentNode(node[ParentID]).filter(data)
                if(!pNode.length) return;
                node.IsCheck = true;
                return that.checkParent(pNode[0], data, PerID, ParentID, rootId);
            },
            recursivetrue: function(){
                let that = this
                let recursiveArray = function(arr){
                    if(arr.Children.length == 0){
                        if(that.maxauthority == false) {
                            if(arr.PerType == "O" && arr.PerName =="查询级"){
                                arr.IsCheck = true
                            }
                        } else {
                            if(arr.PerType == "O" && arr.PerName =="删除级"){
                                arr.IsCheck = true
                            }
                            if(arr.PerType != "O"){
                                arr.IsCheck = true
                            }
                        }
                    } else {
                        arr.IsCheck = true
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        data.IsCheck = true
                        recursiveArray(data)
                        return that.detailDataTree
                    }
                }
            },
            recursivetrueCancel: function(){
                let that = this
                let recursiveArray = function(arr){
                    arr.IsCheck = false
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        data.IsCheck = false
                        recursiveArray(data)
                        return that.detailDataTree
                    }
                }
            },
            recursivetrueSon:function(){
                let that = this
                let id = ""
                let t = ""
                let recursiveArray = function(arr){
                    if(arr.Children.length != 0 && arr.PerID == id){
                        for(let i = 0;i<arr.Children.length;i++){
                            if(t == 1){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = true
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = false
                                }
                            }
                            if(t == 2){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = true
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = false
                                }
                            }
                            if(t == 3){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = true
                                }
                            }
                        }
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data,parentid,type){
                        id = parentid
                        t = type
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.detailDataTree
                    }
                }
            },
            // 取权限最高的
            recursivetrueSon1:function(){
                let that = this
                let pid = ""
                let t = ''
                let level = []
                let recursiveArray = function(arr){
                    if(arr.Children.length != 0 && arr.PerID == pid){
                        for(let i = 0;i<arr.Children.length;i++){
                            if(arr.Children[i].PerName == "查询级" && arr.Children[i].IsCheck == true){
                                level.push(1)
                            }
                            if(arr.Children[i].PerName == "编辑级" && arr.Children[i].IsCheck == true){
                                level.push(2)
                            }
                            if(arr.Children[i].PerName == "删除级" && arr.Children[i].IsCheck == true){
                                level.push(3)
                            }
                        }
                        if (level.length == 1) {
                            t = level[0];
                        } else if (level.length > 1) {
                            t = level[0];
                            for (let i = 0; i < level.length - 1; i++) {
                                t = t < level[i + 1] ? level[i + 1] : t
                            }
                        } else {
                            return
                        }
                        console.log('max' + t)
                        for(let i = 0;i<arr.Children.length;i++){
                            if(t == 1){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = true
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = false
                                }
                            }
                            if(t == 2){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = true
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = false
                                }
                            }
                            if(t == 3){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = true
                                }
                            }
                        }
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data,parentid){
                        pid = parentid
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.detailDataTree
                    }
                }
            },
            // 解析数组
            tickMenuIdFilter: function() {
                let that = this
                that.defaultchecked = [];
                let parentPerIDArr = []
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    obj.PerNameID = !that.$limits.fnIsEmpty(obj.PerNameID)
                        ? !isNaN(obj.PerNameID)
                            ? that.$t('getapi['+ obj.PerNameID +']')
                            : obj.PerNameID
                        : obj.PerName;
                    if (obj.IsCheck == true) {
                        that.defaultchecked.push(obj.PerID);
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        that.$refs.tree.setCheckedKeys(that.defaultchecked)
                        return that.defaultchecked;
                    }
                };
            },
            // 解析数组
            tickMenuIdFilterCheck: function() {
                let that = this
                that.defaultchecked = [];
                let parentPerIDArr = []
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.IsCheck == true) {
                        that.defaultchecked.push(obj.PerID);
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        that.$refs.tree.setCheckedKeys(that.defaultchecked)
                        return that.defaultchecked;
                    }
                };
            },
            // 权限项合并，暂时当前项
            tickMenuIdFilterCheckedData: function() {
                let that = this
                let checkedData = []
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.IsCheck == true) {
                        checkedData.push(obj.PerID);
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        return checkedData;
                    }
                };
            },
            // 合并权限
            appendTree:function() {
                let that = this
                let arr = []
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    for(let i = 0;i<arr.length;i++){
                        if(obj.PerID == arr[i]){
                            obj.IsCheck = true
                            if(obj.PerType == 'O'){
                                that.recursivetrueSon1().filter(that.detailDataTree,obj.ParentID)
                            }
                        }
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr1, arrCheckedData) {
                        arr = arrCheckedData
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr1) {
                            getTickMenuId(rootMenu, arrCheckedData);
                        }
                    }
                };
            },
            save() {
                let that = this
                console.log(that.resetPas)
                console.log(that.dataDetail.Pwd == null)
                if(that.resetPas == 1 && (that.dataDetail.Pwd == '' || that.dataDetail.Pwd == null)){
                    that.$message.warning(that.$t('getapi[899]'));//'请输入密码!'
                    return false
                }
                let parm = {
                    IsAdd: that.addoredit,
                    IsReset: that.resetPas,
                    UserInfo: that.dataDetail,
                    RoleGroupList: that.roleDetail,
                    Lists: that.detailDataTree
                }
                that.$http.urlpost('/Sys/Authority/SaveUserAuthority', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowDetail = false
                    }
                });
            },
            // 增加角色
            showRole() {
                let that = this
                that.isShowRole = true
                that.$refs.role.clearInput(that.isShowRole);
            },
            getrole(row){
                let that = this
                for(let i = 0;i<that.roleDetail.length;i++){
                    if(that.roleDetail[i].roleid == row.num){
                        return false
                    }
                }
                that.roleDetail = [...that.roleDetail,{
                    roleid: row.num,
                    rolename: row.rolename
                }]
                for(let i = 0;i<that.roleDetail.length;i++){
                    if(that.roleDetail[i].roleid != 0){
                        that.mergeTree(that.roleDetail[i].roleid)
                    }
                }
            },
            mergeTree(id){
                let that = this
                let parm = {
                    cfstate: 2,
                    keytype: "",
                    roleid: id
                }
                that.$http.urlpost('/Sys/Authority/GetRoleAuthorityList', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.RolePer
                        if(that.detailDataTree.length == 0){
                            that.detailDataTree = data
                            that.tickMenuIdFilter().filter(that.detailDataTree);
                        } else {
                            let cacheCheckedData = that.tickMenuIdFilterCheckedData().filter(data);
                            that.appendTree().filter(that.detailDataTree, cacheCheckedData);
                            that.tickMenuIdFilter().filter(that.detailDataTree);
                        }
                    }
                });
            },
            selectRow(row){
                let that = this
                that.selectrow = row
                /*let parm = {
                    cfstate: 2,
                    keytype: "",
                    roleid: row.roleid
                }
                that.$http.urlpost('/Sys/Authority/GetRoleAuthorityList', parm, function (res) {
                    if (res.Success == 1) {
                        that.detailDataTree = res.DataContent.RolePer
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });*/
            },
            deleteRole(){
                let that = this
                if(that.selectrow.roleid == 0){
                    return
                }
                for(let i = 0;i<that.roleDetail.length;i++){
                    if(that.selectrow.roleid == that.roleDetail[i].roleid){
                        that.roleDetail.splice(i,1)
                    }
                }
                that.roleDetail = [...that.roleDetail]
                if(that.roleDetail.length == 1 || that.roleDetail.length == 0){
                    that.clearTree().filter(that.detailDataTree);
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                } else {
                    that.detailDataTree = []
                    for(let i = 0;i<that.roleDetail.length;i++){
                        if(that.roleDetail[i].roleid != 0){
                            that.mergeTree(that.roleDetail[i].roleid)
                        }
                    }
                }
            },
            saveRole(){
                let that =this
                that.isShowSaveRole = true
            },
            confirmSaveRole() {
                let that = this
                let parm = {
                    roleid: that.roleid,
                    rolename: that.rolename,
                    groupid: that.groupid,
                    Lists: that.detailDataTree
                }
                that.$http.urlpost('/Sys/Authority/SaveRoleGroups', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            searchTree(){
                let that = this
                if(that.treeQueryKey == ""){
                    that.$message.warning(that.$t('getapi[8833]'));//'请输入查询关键字！'
                    return
                }
                that.searchIndex = null;
                that.defaultEexpandedkeys = []
                that.searchData = []
                let searchInput = that.treeQueryKey;
                that.getSearchNode().filter(that.detailDataTree)
                if (this.searchData.length) {//存在符合查询条件的节点
                    this.searchIndex = 0;
                    //展开符合条件节点的父节点（使查询节点显示出来）
                    that.defaultEexpandedkeys = that.getParentsId(this.searchData[0], this.detailDataTree, 'PerID','ParentID', '01');
                    console.log(that.defaultEexpandedkeys)
                    this.$nextTick(() => {//显示完成后执行
                        this.$refs.tree.setCurrentKey(this.searchData[0].PerID);//高亮查询到的第一个节点
                    });
                } else {
                    //Message需要引入  import {Message} from 'element-ui'
                    that.$message.warning(that.$t('getapi[8832]'));//'未找到任何匹配数据！'
                }
            },
            next() {
                let that = this
                console.log(that.searchIndex)
                console.log(that.searchData)
                if(that.searchIndex >= that.searchData.length -1){
                    that.$message.warning(that.$t('getapi[8832]'))//'未找到任何匹配数据！'
                    return false
                }
                that.searchIndex += 1;
                that.searchIndex = that.searchIndex < that.searchData.length ? that.searchIndex : 0;
                that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchIndex], that.detailDataTree, 'PerID','ParentID', '01');
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].PerID);
                    setTimeout(() => {
                        let node = document.querySelector('#searchtree-eletree .is-current');
                        if (node) {
                            setTimeout(() => {
                                // node.scrollIntoView();
                                let top = $(node).position().top;
                                $("#searchtree-eletree").scrollTop(top);
                            }, 500);
                        }
                    }, 0);
                });
            },
            back() {
                let that = this
                if(that.searchIndex == 0){
                    that.$message.warning(that.$t('getapi[8832]'))//'未找到任何匹配数据！'
                    return false
                }
                that.searchIndex -= 1;
                that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchIndex], that.detailDataTree, 'PerID','ParentID', '01');
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].PerID);
                    setTimeout(() => {
                        let node = document.querySelector('#searchtree-eletree .is-current');
                        if (node) {
                            setTimeout(() => {
                                // node.scrollIntoView();
                                let top = $(node).position().top;
                                $("#searchtree-eletree").scrollTop(top);
                            }, 500);
                        }
                    }, 0);
                });
            },
            getSearchNode:function(){
                let that = this
                let recursiveArray = function(arr){
                    if(arr.PerName.indexOf(that.treeQueryKey) > -1){
                        that.searchData.push(arr)
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.searchData
                    }
                }
            },
            getParentsId(node, data, PerID, ParentID, rootId, parentsId = [] ){
                let that = this
                if(!node) return [rootId, ...parentsId];
                if(node[ParentID] == rootId) return [node[ParentID], ...parentsId];
                /*let pNode = data.filter(item => item[PerID] == node[ParentID]);*/
                let pNode = that.getParentNode(node[ParentID]).filter(data)
                console.log('7777' + pNode)
                if(!pNode.length) return parentsId;
                parentsId.push(pNode[0][PerID]);
                return that.getParentsId(pNode[0], data, PerID, ParentID, rootId, parentsId);
            },
            position(){
                this.$nextTick(() => {
                    let that = this
                    let top1 = $("#searchtree-eletree").position().top;
                    let top2 = $("#searchtree-eletree .is-current").position().top
                    let value = top2 - top1
                    $("#searchtree-eletree").scrollTop(value)
                })
            },
            getParentNode: function(ParentID){
                let that = this
                let parentID = []
                let recursiveArray = function(arr){
                    if(arr.PerID == ParentID){
                        parentID.push(arr)
                        return
                    } else {
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu);
                        }
                        return parentID
                    }
                }
            },
            selectemployee() {
                let that = this;
                that.employeeVisible = true;
                that.$refs.roleemp.clearInput(this.employeeVisible);
            },
            getroleemp(data) {
                let that = this;
                console.log(data)
                that.dataDetail.UserNum = data.usernum
                that.dataDetail.UserName = data.username
                that.dataDetail.DeptID = parseInt(data.deptid)
                that.dataDetail.PostID = parseInt(data.postid)
                that.dataDetail.postname = data.postname
            },
            del(row){
                let that = this
                that.$confirm(that.$t('getapi[1923]'), that.$t('getapi[194]'), {//"确认要删除吗?"
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            usernum: that.selData[0].usernum,
                            usercode: that.selData[0].userid
                        }
                        that.$http.urlpost('/Sys/Authority/DelUserAuthority', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.reflash()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 清空树
            // 解析数组
            clearTree: function() {
                let that = this
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    obj.IsCheck = false
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        return that.detailDataTree;
                    }
                };
            },
            /*页面权限设置*/
            pageAuthSet(){
                let that = this
                console.log(that.selData)
                that.UserID =  that.selData[0].usernum
                that.UserName =  that.selData[0].username
                that.pagename = ''
                that.dataAuth = []
                that.pageAuthTips = ''
                that.isShowUserAuth = true
            },
            getPageArr(){
                let that = this
                let parm = {}
                that.$http.urlpost('/PageAuthl/GetSys_PageAuthViewGroupBy', parm, function (res) {
                    if (res.Success == 1) {
                        that.pagearr = res.DataContent
                    }
                });
            },
            getPageData(){
                let that = this
                let arr = [];
                arr.push({
                    query_Condition: that.pagename,
                    query_field_name: "Page_Name",
                    query_field_type: "txt",
                    query_sort: "",
                    row_sign: 0
                },{
                    query_Condition: that.UserName,
                    query_field_name: "UserName",
                    query_field_type: "txt",
                    query_sort: "",
                    row_sign: 0
                })
                let data = {
                    PageIndex: 1,
                    PageSize: 100000,
                    SelectIndex: 0,
                    Param: arr
                };
                that.$http.urlpost('/PageAuthl/GetSys_PageAuth_UserView', data, function(res) {
                    if (res.Success == 1) {
                        if(res.DataContent.length != 0){
                            that.dataAuth = res.DataContent
                            that.pageAuthTips = that.$t('getapi[13132]')
                        } else {
                            that.pageAuthTips = that.$t('getapi[13131]')
                            let arr = []
                            arr.push({
                                query_Condition: that.pagename,
                                query_field_name: "Page_Name",
                                query_field_type: "txt",
                                query_sort: "",
                                row_sign: 0
                            })
                            let parm = {
                                PageIndex: 1,
                                PageSize: 100000,
                                SelectIndex: 0,
                                Param: arr
                            };
                            that.$http.urlpost('/PageAuthl/GetSys_PageAuthView', parm, function(res) {
                                if (res.Success == 1) {
                                    that.dataAuth = res.DataContent
                                    for(let i=0;i<that.dataAuth.length;i++){
                                        that.$set(that.dataAuth[i], 'Exclusively_ID', 0);
                                        that.$set(that.dataAuth[i], 'AuthCode', "1");
                                    }
                                }
                            });
                        }
                    }
                });

            },
            saveUserAuth(){
                let that = this
                if(that.pagename == ''){
                    that.$message.warning(that.$t('getapi[13129]'))
                    return false
                }
                let arr = []
                for(let i=0;i<that.dataAuth.length;i++){
                    arr = [...arr,{
                        Exclusively_ID: that.dataAuth[i].Exclusively_ID,
                        UserID: that.UserID,
                        UserName: that.UserName,
                        Page_Name: that.dataAuth[i].Page_Name,
                        Page_Tab: that.dataAuth[i].Page_Tab,
                        Field_Name: that.dataAuth[i].Field_Name,
                        Sort: 0,
                        AuthCode: that.dataAuth[i].AuthCode,
                        Page_LangId: that.dataAuth[i].Page_LangId,
                        Field_LangId: that.dataAuth[i].Field_LangId
                    }]
                }
                let parm = arr
                that.$http.urlpost('/PageAuthl/SaveSys_PageAuth_User', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getPageData()
                    }
                });
            },
            delUserAuth(){
                let that = this
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let str = ''
                        for(let i=0;i<that.dataAuth.length;i++){
                            str = str + that.dataAuth[i].Exclusively_ID + ','
                        }
                        let parm = {
                            ids: str,
                            LangType:that.$processdata.getLang(),
                        };
                        that.$http.urlpost('/PageAuthl/DeleteSys_PageAuth_UserByID', parm, function(res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getPageData();
                            }
                        });
                    })
                    .catch(() => {});
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
    /deep/.el-scrollbar__wrap{
        overflow: scroll;
        overflow-y: scroll;
    }
</style>
